export default __webpack_public_path__ + "static/media/closeSesionImage.c3a9da71.svg";